import React, { memo, useState } from 'react'

import { bMobile } from '@/utils'

const PC = React.lazy(() => import('./PC'))
const H5 = React.lazy(() => import('./H5'))

const ConfigProvider = ({ children }) => {
  const [bPhone, setBPhone] = useState(bMobile)

  return <>{!bPhone ? <PC>{children}</PC> : <H5>{children}</H5>}</>
}

export default memo(ConfigProvider)
